import { render, staticRenderFns } from "./breath_real.vue?vue&type=template&id=48d52bc3&scoped=true&"
import script from "./breath_real.vue?vue&type=script&lang=js&"
export * from "./breath_real.vue?vue&type=script&lang=js&"
import style0 from "./breath_real.vue?vue&type=style&index=0&id=48d52bc3&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d52bc3",
  null
  
)

export default component.exports